import * as style from './styles.css';
import { clsx } from 'clsx';
import { ITypographyComponentProps, TDeviceType, TMemoForwardRefComponent } from '@cian/ui-kit';
import * as React from 'react';
import { getUTP } from './constants';

interface IBuyWithCianProps {
  device: TDeviceType;
  onModalClick: () => void;
  onLinkClick: () => void;
  ItemTitle: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
}

export const BuyWithCian: React.FC<IBuyWithCianProps> = ({ device, ItemTitle, onModalClick, onLinkClick }) => {
  const UPD = getUTP(onModalClick, onLinkClick);

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['title']}>Что вы получите</div>
      <div className={style['items']}>
        <div className={style['items-row']}>
          {UPD.map(({ title, toolTipText, imageClass, button }, index) => (
            <div className={style['item']} key={index}>
              <div className={clsx(style['item-image'], style[imageClass])} />
              <div className={style['item-title']}>
                <ItemTitle color="text-primary-default">{title}</ItemTitle>
              </div>
              <div className={style['item-descr']}>{toolTipText}</div>
              {button && <div className={style['item-button']}>{button}</div>}
            </div>
          ))}
          <div className={style['item-with-label']}>
            <div className={clsx(style['item'], style['item-accent'])}>
              <div className={clsx(style['item-image'], style['pay'])} />
              <div className={style['item-title']}>
                <ItemTitle color="theme-white">Почувствуете себя комфортно</ItemTitle>
              </div>
              <div className={style['item-descr']}>Специалист Циана курирует сделку и защищает ваши интересы</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
